import SuccessIcon from '@assets/images/success.svg?react'
import dompurify from 'dompurify'
import parse from 'html-react-parser'
import { tr } from 'mmfintech-commons'
import { PreviewMessageStyled } from './PreviewMessage.styled'

export const PreviewMessage = ({ result }) => {
  const message = result.replace(/\r?\n/g, '<br/>').replace(/\\n/g, '<br/>')

  return (
    <PreviewMessageStyled>
      <SuccessIcon />
      <div>
        <div className='title'>{tr('FRONTEND.DEPOSIT.RESULT.SUCCESS', 'Success')}</div>
        {parse(dompurify.sanitize(message))}
      </div>
    </PreviewMessageStyled>
  )
}
